import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';

interface ProfileSetupGateProps {
  children?: React.ReactNode;
}

/**
 * Guards routes that require a complete profile (terms accepted + username set).
 * If either condition is unmet, redirects to the combined /setup-profile page.
 */
export function ProfileSetupGate({ children }: ProfileSetupGateProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[color:var(--color-background)]">
        <LoadingSpinner />
      </div>
    );
  }

  if (!user || !user.username || !user.termsAcceptedAt) {
    return <Navigate to="/setup-profile" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
}
